//=====================================
//jquery
// import $ from 'jquery';
// window.$ = $;
// window.jQuery = $;
//=====================================
// window.$ = window.jQuery = require('jquery');
// global.$ = global.jQuery = require('jquery');
// window.App = window.App  || {};
// window.Popper = require('@popperjs/core');

// //=====================================
// //Bootstrap
// import * as bootstrap from 'bootstrap';
// // Or import only needed plugins
// import { Tooltip as Tooltip, Toast as Toast, Popover as Popover } from 'bootstrap';
// // Or import just one
// // import Alert as Alert from '../node_modules/bootstrap/js/dist/alert';
// //=====================================
// require('bootstrap');



//=====================================
// jQuery
//=====================================
const $ = require('jquery');

window.$ = window.jQuery = $;
global.$ = global.jQuery = $;

//=====================================
// App
//=====================================
window.App = window.App || {};

//=====================================
// Popper
//=====================================
window.Popper = require('@popperjs/core');

//=====================================
// Bootstrap 5
//=====================================
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;




//=====================================
//Gsap
//=====================================
import { gsap } from "gsap/dist/gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { ScrollToPlugin } from "gsap/dist/ScrollToPlugin";
import { Draggable } from "gsap/dist/Draggable"; // Draggableを追加
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, Draggable);

//=====================================
//SplitType
//=====================================
// const SplitType = require('split-type').default;
// window.SplitType = SplitType;

//=====================================
//Swiper
// import Swiper JS
// Swiper, Keyboard, Navigation, Pagination, Controller, History, Autoplay, EffectFade, EffectCube, EffectFlip, EffectCoverflow, Lazy, A11y
//=====================================
const Swiper = require('swiper/bundle').default;
const { Navigation, Pagination, Autoplay, EffectFade } = Swiper;
Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);
window.Swiper = Swiper;

//=====================================
// SweetAlert2
//=====================================
import Swal from 'sweetalert2';
window.Swal = Swal;
// Example usage of SweetAlert2
// document.addEventListener('DOMContentLoaded', () => {
//     const modalBtn = document.getElementById('modalBtn');
//     if (modalBtn) {
//         modalBtn.addEventListener('click', () => {
//             Swal.fire({
//                 title: 'モーダルタイトル',
//                 text: 'これは説明文です。',
//                 icon: 'info',
//                 confirmButtonText: '閉じる'
//             });
//         });
//     }
// });

//=====================================
//FANCY BOX
//=====================================
// import {Fancybox } from "@fancyapps/ui";
// window.Fancybox = Fancybox;

/////////////////////////////////////////////
//MARQUEE #TEST 
/////////////////////////////////////////////
// main.js（最初に貼っていたコードの末尾などに追加）
import { initMarquee } from './inc_marquee';
// import { initSlotNumber } from './inc_slotNumber';
// import { initGsapAnimations } from './inc_inc_gsapScrollAnim.js';




//=====================================
//Muuri
//=====================================
const Muuri = require('muuri').default;
window.Muuri = Muuri;




////////////////////////////////////////////////////
// CONSTRUCTION FILTER
////////////////////////////////////////////////////
window.App.initConstructionFilter = function () {

  // 二重初期化防止
  if (window.App.isConstructionFilterInitialized) return;
  window.App.isConstructionFilterInitialized = true;

  // 必須要素チェック
  if (!$('#section-archive-construction').length) return;
  if (!$('#constructionFilterCanvas').length) return;
  if (!$('#constructionFilterOverlay').length) return;

  const $body = $('body');
  const $overlay = $('#constructionFilterOverlay');
  const $sheet = $('#constructionFilterCanvas');

  ////////////////////////////////////////////////////
  // OPEN
  ////////////////////////////////////////////////////
  function openFilterSheet() {

    $body
      .addClass('is-construction-filter-open')
      .addClass('is-scroll-lock');

    $sheet.attr('aria-hidden', 'false');

  }

  ////////////////////////////////////////////////////
  // CLOSE
  ////////////////////////////////////////////////////
  function closeFilterSheet() {

    $body
      .removeClass('is-construction-filter-open')
      .removeClass('is-scroll-lock');

    $sheet.attr('aria-hidden', 'true');

  }

  ////////////////////////////////////////////////////
  // OPEN BUTTON
  ////////////////////////////////////////////////////
  $(document).on(
    'click.constructionFilterOpen',
    '.btn-filter-open, .btn-filter-status',
    function (e) {

      e.preventDefault();
      e.stopPropagation();

      openFilterSheet();

    }
  );

  ////////////////////////////////////////////////////
  // CLOSE BUTTON
  ////////////////////////////////////////////////////
  $(document).on(
    'click.constructionFilterClose',
    '.btn-filter-close',
    function (e) {

      e.preventDefault();
      e.stopPropagation();

      closeFilterSheet();

    }
  );

  ////////////////////////////////////////////////////
  // OVERLAY CLOSE
  ////////////////////////////////////////////////////
  $overlay.on(
    'click.constructionFilterOverlay',
    function (e) {

      e.preventDefault();
      e.stopPropagation();

      closeFilterSheet();

    }
  );

  ////////////////////////////////////////////////////
  // ESC CLOSE
  ////////////////////////////////////////////////////
  $(document).on(
    'keydown.constructionFilterEsc',
    function (e) {

      if (e.key === 'Escape') {
        closeFilterSheet();
      }

    }
  );

  ////////////////////////////////////////////////////
  // SHEET内スクロール
  // Safari対策
  ////////////////////////////////////////////////////
  $sheet.on('touchmove', function (e) {
    e.stopPropagation();
  });

  ////////////////////////////////////////////////////
  // FILTER CLICK
  ////////////////////////////////////////////////////
  $(document).on(
    'click.constructionFilterLink',
    '#constructionFilterCanvas .construction-filter-panel a',
    function (e) {

      const href = $(this).attr('href');

      if (!href || $(this).attr('aria-disabled') === 'true') {

        e.preventDefault();
        return false;

      }

      e.preventDefault();
      e.stopPropagation();

      const $li = $(this).closest('li');

      $li.addClass('is-selecting');

      $('.btn-filter-open span').text('絞り込み中…');

      // 即閉じる
      closeFilterSheet();

      // 少しだけ待って遷移
      setTimeout(function () {

        window.location.href = href;

      }, 120);

    }
  );

};
////////////////////////////////
//STICKY
///////////////////////////////
window.App.removeClassOnReach = function(options){

  const settings = $.extend({
    target: '',
    trigger: '',
    removeClass: '',
    offset: 0
  }, options);

  const $target = $(settings.target);
  const $trigger = $(settings.trigger);

  if (!$target.length || !$trigger.length || !settings.removeClass) return;

  function update(){
    const triggerTop = $trigger.offset().top;
    const scrollBottom = $(window).scrollTop() + $(window).height();

    if (scrollBottom >= triggerTop + settings.offset) {
      $target.removeClass(settings.removeClass);
    } else {
      $target.addClass(settings.removeClass);
    }
  }

  update();

  $(window).on('scroll.removeClassOnReach resize.removeClassOnReach', function(){
    window.requestAnimationFrame(update);
  });
};










///////////////////////////////////////////

////////////////////////////////
// STICKY：指定地点でclassを外す + GSAPで移動補正
////////////////////////////////
window.App.removeClassOnReach = function(options){

  const settings = $.extend({
    target: '',
    trigger: '',
    removeClass: '',
    offset: 0,
    duration: .35,
    ease: 'power3.out'
  }, options);

  const $target = $(settings.target);
  const $trigger = $(settings.trigger);

  if (!$target.length || !$trigger.length || !settings.removeClass) return;

  let isRemoved = !$target.hasClass(settings.removeClass);
  let ticking = false;

  function switchClass(shouldRemove){
    if (shouldRemove === isRemoved) return;

    const el = $target[0];
    const before = el.getBoundingClientRect();

    if (shouldRemove) {
      $target.removeClass(settings.removeClass);
    } else {
      $target.addClass(settings.removeClass);
    }

    const after = el.getBoundingClientRect();
    const dx = before.left - after.left;
    const dy = before.top - after.top;

    gsap.killTweensOf(el);
    gsap.set(el, { x: dx, y: dy });

    gsap.to(el, {
      x: 0,
      y: 0,
      duration: settings.duration,
      ease: settings.ease,
      clearProps: 'transform'
    });

    isRemoved = shouldRemove;
  }

  function update(){
    ticking = false;

    const triggerTop = $trigger.offset().top;
    const scrollBottom = $(window).scrollTop() + $(window).height();
    const shouldRemove = scrollBottom >= triggerTop + settings.offset;

    switchClass(shouldRemove);
  }

  function requestUpdate(){
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  update();

  $(window).on('scroll.removeClassOnReach resize.removeClassOnReach', requestUpdate);
};







///////////////////////////////
//SWIPER
////////////////////////////////
const responsiveSwipers = new Map();
function initResponsiveSwiper(selector, options, maxWidth = 960) {
  document.querySelectorAll(selector).forEach(function (el) {
    if (window.innerWidth >= maxWidth) {
      if (responsiveSwipers.has(el)) {
        responsiveSwipers.get(el).destroy(true, true);
        responsiveSwipers.delete(el);
      }
      return;
    }

    if (responsiveSwipers.has(el)) return;

    const swiper = new Swiper(el, options);
    responsiveSwipers.set(el, swiper);
  });
}
function checkResponsiveSwipers() {
  initResponsiveSwiper('.js-swip-flow-repeat', {
    initialSlide: 0,
    autoHeight: false,
    effect: 'coverflow',
    grabCursor: true,
    centeredSlides: true,
   slidesPerView: 1.05,
    spaceBetween: 0,
    loop: true,
    coverflowEffect: {
      rotate: 0,
      stretch: -28,
      depth: 140,
      modifier: 1.4,
      slideShadows: false,
    },
    breakpoints: {
      576: {
        slidesPerView: 1.35,
        coverflowEffect: {
          rotate: 0,
          stretch: -36,
          depth: 160,
          modifier: 1.4,
          slideShadows: false,
        },
      },
      768: {
        slidesPerView: 2.05,
        coverflowEffect: {
          rotate: 0,
          stretch: -44,
          depth: 180,
          modifier: 1.3,
          slideShadows: false,
        },
      },
    },
  });

  initResponsiveSwiper('.js-swip-flow-system', {
    initialSlide: 1,
    effect: 'coverflow',
    grabCursor: true,
    centeredSlides: true,
  slidesPerView: 1.15,
    spaceBetween: 0,
    loop: false,
    coverflowEffect: {
      rotate: 0,
      stretch: -28,
      depth: 140,
      modifier: 1.4,
      slideShadows: false,
    },
    breakpoints: {
      576: {
        slidesPerView: 1.55,
        coverflowEffect: {
          rotate: 0,
          stretch: -36,
          depth: 160,
          modifier: 1.4,
          slideShadows: false,
        },
      },
      768: {
        slidesPerView: 2.05,
        coverflowEffect: {
          rotate: 0,
          stretch: -44,
          depth: 180,
          modifier: 1.3,
          slideShadows: false,
        },
      },
    },
  });
initResponsiveSwiper('.js-swip-flow-step', {
  initialSlide: 0,
  effect: 'coverflow',
  grabCursor: true,
  centeredSlides: true,
  slidesPerView: 1.05,
  spaceBetween: 0,
  loop: false,
  coverflowEffect: {
    rotate: 0,
    stretch: -18,
    depth: 100,
    modifier: 1.2,
    slideShadows: false,
  },
  breakpoints: {
    576: {
      slidesPerView: 1.35,
      spaceBetween: 18,
    },
    768: {
      slidesPerView: 2.05,
      spaceBetween: 20,
      centeredSlides: false,
    },
  },
});
}
$(function () {
  checkResponsiveSwipers();
});

$(window).on('resize', function () {
  checkResponsiveSwipers();
});


$(function(){
  initMarquee();
///////////////////////////////
// SLIDE-DOWN
///////////////////////////////
$(".item-slidedown dt").on("click", function(e) {
  e.preventDefault(); // デフォルト動作を防ぐ

  var parent = $(this).closest(".item-slidedown");
  var answer = parent.find("dd");
  var isOpen = parent.attr("aria-expanded") === "true";

  if (isOpen) {
    parent.attr("aria-expanded", "false");
    answer.slideUp(300);
  } else {
    parent.attr("aria-expanded", "true");
    answer.slideDown(300);
  }
});

// dd 内をクリックしても親要素のイベントを発火させない
$(".item-slidedown dd").on("click", function(e) {
  e.stopPropagation();
});

///////////////////////////////
// SWITCH BUTTON OPEN ALL
///////////////////////////////
$(".toggle").on("click", function() {
  $(this).toggleClass("checked");
  var isChecked = !$(this).find('input[name="check"]').prop("checked");
  $(this).find("input").prop("checked", isChecked);

  // data-target の取得
  var targetSection = $(this).attr("data-target");

  // 該当の section 内の dt 要素を操作
  $("#" + targetSection).find("dt").each(function() {

      if (isChecked) {
          $(this).parent('dl').attr("aria-expanded", "true");
          $(this).next("dd").slideDown(300);
      } else {
          $(this).parent('dl').attr("aria-expanded", "false");
          $(this).next("dd").slideUp(300);
      }
  });
});


/////////////////////////////////////////////
// TEXTAREA 自動伸縮
/////////////////////////////////////////////
$(document).on('input', '.js-auto-textarea', function() {
  this.style.height = 'auto';                  // 一旦リセット
  this.style.height = this.scrollHeight + 'px'; // 中身に合わせる
});

// 初期表示時にも高さ合わせる（重要）
$('.js-auto-textarea').each(function() {
  this.style.height = 'auto';
  this.style.height = this.scrollHeight + 'px';
});

/////////////////////////////////////////////
// CONTACT FORM 7
// バリデーションエラー表示
/////////////////////////////////////////////
/* ---------------------------------------------------------
 * エラーメッセージをクリックしたら消す
 * ------------------------------------------------------ */
$(document)
  .off('click.cf7Validation', '.wpcf7-not-valid-tip')
  .on('click.cf7Validation', '.wpcf7-not-valid-tip', function() {
    $(this).fadeOut(150);
  });

/* ---------------------------------------------------------
 * 入力項目にフォーカスしたら
 * その項目のエラーメッセージを消す
 * ------------------------------------------------------ */
$(document)
  .off('focus.cf7Validation', '.wpcf7-form-control')
  .on('focus.cf7Validation', '.wpcf7-form-control', function() {

    $(this)
      .closest('.wpcf7-form-control-wrap')
      .find('.wpcf7-not-valid-tip')
      .fadeOut(150);
  });



/////////////////////////////////////////////
// SPのMENU内アコーディオン
// accordionMode:
// true  = 1つ開くと他は閉じる
// false = それぞれ独立して開閉する
/////////////////////////////////////////////
document.addEventListener('click', function(e) {
  const accordionMode = false; // ← アコーディオンに戻す場合は true

  const btn = e.target.closest('#global-sp-menu .sp-menu-toggle');
  if (!btn) return;

  const item = btn.closest('.has-child');
  if (!item) return;

  const isOpen = item.classList.contains('is-open');

  // -----------------------------------------
  // アコーディオン動作
  // 他の開いているメニューを閉じる
  // -----------------------------------------
  if (accordionMode) {
    document.querySelectorAll('#global-sp-menu .has-child.is-open').forEach(function(el) {
      if (el !== item) {
        el.classList.remove('is-open');

        const openBtn = el.querySelector('.sp-menu-toggle');
        if (openBtn) {
          openBtn.setAttribute('aria-expanded', 'false');
        }
      }
    });
  }

  // -----------------------------------------
  // 共通処理
  // クリックしたメニューを開閉
  // -----------------------------------------
  item.classList.toggle('is-open', !isOpen);
  btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
});

/////////////////////////////////////////////
// SP MENU：同一ページ内アンカーだけ閉じる
/////////////////////////////////////////////
$(document).on("click", "#global-sp-menu a", function () {
  if ($(this).hasClass("menu-close-ignore")) return;

  const href = $(this).attr("href");
  if (!href) return;

  // 完全なページ遷移リンクは閉じない
  // ページ遷移すれば自然にメニューは消えるため
  if (!$("body").hasClass("is-sp-menu")) return;

  // #section だけの同一ページアンカー
  if (href.startsWith("#")) {
    $("#global_burgermenu > button").trigger("click");
    return;
  }

  // 現在ページURL + #section の同一ページアンカーにも対応
  try {
    const linkUrl = new URL(href, window.location.href);
    const currentUrl = new URL(window.location.href);

    const isSamePage =
      linkUrl.origin === currentUrl.origin &&
      linkUrl.pathname.replace(/\/$/, "") === currentUrl.pathname.replace(/\/$/, "") &&
      linkUrl.search === currentUrl.search &&
      linkUrl.hash;

    if (isSamePage) {
      $("#global_burgermenu > button").trigger("click");
    }

  } catch (e) {
    // URL判定できないものは何もしない
  }
});

/////////////////////////////////////////////
// HEADER DROPDOWN MENU
/////////////////////////////////////////////
  // メニューアイテムを選択
  $('li[aria-expanded]').each(function() {
    var $dropdown = $(this); // 現在のリストアイテム
    var $trigger = $dropdown.find('a'); // 直下のリンク (hover対象)
    var $menu = $dropdown.find('.menu_dropdown'); // ドロップダウンメニュー

    // hover で開く
    $trigger.on('mouseenter', function() {
      $dropdown.attr('aria-expanded', 'true');
      $('body').addClass("is_filter");
    });

    // ドロップダウンメニューにもmouseenterを設定
    $menu.on('mouseenter', function() {
      $dropdown.attr('aria-expanded', 'true');
      $('body').addClass("is_filter");
    });

    // マウスが外れたら閉じる
    $dropdown.on('mouseleave', function() {
      // li から外れたときにメニューが閉じる
      $dropdown.attr('aria-expanded', 'false');
      $('body').removeClass("is_filter");
    });

    // ドロップダウンメニューから外れたときも閉じる
    $menu.on('mouseleave', function() {
      $dropdown.attr('aria-expanded', 'false');
      $('body').removeClass("is_filter");
    });
  });




///////////////////////////////////////////////
$('.js-number').attr("inputmode", "tel");
$('.js-number').on('input', function() {
    // 全角数字を半角に変換
    var convertedValue = $(this).val().replace(/[０-９]/g, function(s) {
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
    });
    $(this).val(convertedValue);
});







//////////////////////////////
// カウントアップ
//////////////////////////////
setTimeout(function () {

  // =====================================
  // 設定値（ここだけ触れば挙動変更可）
  // =====================================
  var DEFAULT_ZERO_ANIMATE_START = 100; // 最終値が0のときの開始値
  var DURATION = 800;

  $(".txt-num > i, .count-num > i").each(function () {

    var $target = $(this);
    var targetText = $target.text().trim();

    // 初期状態
    $target.removeClass("is-counting is-done");

    // -------------------------------------
    // 数値抽出（小数点対応）
    // -------------------------------------
    var numericText = targetText.replace(/[^0-9.]/g, "");
    if (!numericText) return;

    var isFloat = numericText.indexOf(".") !== -1;
    var targetNumber = isFloat
      ? parseFloat(numericText)
      : parseInt(numericText, 10);

    if (isNaN(targetNumber)) return;

    var decimalLength = isFloat
      ? (numericText.split(".")[1]?.length || 0)
      : 0;

    var intPaddingLength = numericText.split(".")[0].length;

    var hasAnimated = false;

    // -------------------------------------
    // 初期表示値（必ず 0）
    // -------------------------------------
    var displayInitialValue = isFloat
      ? (0).toFixed(decimalLength)
      : "0".padStart(intPaddingLength, "0");

    //表示用に初期値を書き換える
    // $target.text(displayInitialValue);

    // -------------------------------------
    // アニメーション開始・終了値
    // -------------------------------------
    var isZeroTarget = targetNumber === 0;

    // アニメ開始値（表示用とは別）
    var animateStartValue = isZeroTarget
      ? DEFAULT_ZERO_ANIMATE_START
      : 0;

    // アニメ終了値
    var animateEndValue = targetNumber;

    // -------------------------------------
    // アニメーション本体
    // -------------------------------------
    function animateNumber() {
      if (hasAnimated) return;
      hasAnimated = true;

      $target.addClass("is-counting");

      $({ countNum: animateStartValue }).animate(
        { countNum: animateEndValue },
        {
          duration: DURATION,
          easing: "linear",

          step: function (now) {
            var value;

            if (isFloat) {
              value = now.toFixed(decimalLength);
              var parts = value.split(".");
              parts[0] = parts[0].padStart(intPaddingLength, "0");
              value = parts.join(".");
            } else {
              value = Math.floor(now)
                .toString()
                .padStart(intPaddingLength, "0");
            }

            $target.text(value);
          },

          complete: function () {
            var finalValue = isFloat
              ? animateEndValue.toFixed(decimalLength)
              : animateEndValue.toString().padStart(intPaddingLength, "0");

            $target.text(finalValue);

            $target
              .removeClass("is-counting")
              .addClass("is-done");
          }
        }
      );
    }

    // -------------------------------------
    // ScrollTrigger
    // -------------------------------------
    gsap.to({}, {
      duration: 0.01,
      scrollTrigger: {
        trigger: $target.parent()[0],
        start: "top 80%",
        onEnter: animateNumber,
        once: true
      }
    });

  });

}, 800);


  var headerH = $("#header-pc").outerHeight(true); // headerの高さを取得
  function toggleHeaderClass() {
    // $('body').toggleClass('is_scrollstart', $(window).scrollTop() >= headerH);
  }
  // 画面をスクロールしたら動かす
  $(window).scroll(toggleHeaderClass);
  // ページが読み込まれたらすぐに動かす
  $(window).on('load', toggleHeaderClass);
  

/////////////////////////////////////////////
//MODAL 外部から呼び出すため
/////////////////////////////////////////////
window.App.loadSectionId = function(source, modalId, modalTitle) {
  if (source.startsWith('#')) {
      // Copy content from the specified element
      var content = $(source).html();
      $("#ajx_content_output").html(content);
      $(modalId).find('.modal-title').html(modalTitle);
      $(modalId).modal('show');
  } else {
      // Load content from the specified URL
      $.ajax({
          type: 'GET',
          url: source,
          success: function(data) {
              $("#ajx_content_output").html(data);
              $(modalId).find('.modal-title').html(modalTitle);
              $(modalId).modal('show');
          }
      });
  }
};

/////////////////////////////////////////////
//TOOLTIP
/////////////////////////////////////////////
  $('[data-toggle="tooltip"]').tooltip()
/////////////////////////////////////////////
//MODAL 外部から呼び出すため
/////////////////////////////////////////////
window.App.loadSection = function(url, modalId,modalTitle) {
  $.ajax({
    type: 'GET',
    url: url,
    success: function(data) {
      $(modalId).find(".ajx_content_output").html(data);
      $(modalId).find('.modal-title').html(modalTitle);
      $(modalId).modal('show');
    }
  });
};
/////////////////////////////////////////////
// SP BURGER MENU
/////////////////////////////////////////////
$('#global_burgermenu > button').on('click', function(e) {
  e.preventDefault();

  const $btn = $(this);
  const isOpen = !$btn.hasClass('active');

  $btn.toggleClass('active', isOpen);

  if (isOpen) {
    $('body')
      .addClass('is-sp-menu is-scroll-lock')
      .removeClass('rm-sp-menu');
  } else {
    $('body')
      .removeClass('is-sp-menu is-scroll-lock')
      .addClass('rm-sp-menu');
  }

  return false;
});

// メニュー外クリックで閉じたい場合
$(document).on('click', '#global-sp-menu', function(e) {
  if ($(e.target).closest('.scroll-inner').length) return;
  $('#global_burgermenu > button').trigger('click');
});

// ESCで閉じる
$(document).on('keydown.spMenu', function(e) {
  if (e.key === 'Escape' && $('body').hasClass('is-sp-menu')) {
    $('#global_burgermenu > button').trigger('click');
  }
});

// $("#global-sp-menu").on("click",function(){
//   $('#global_burgermenu > button').trigger('click');
// })

// $(document).on('click', function(event) {
//   if ($('body').hasClass('is-sp-menu') && !$(event.target).closest("#global-sp-menu").length) {
//     $('#global_burgermenu > button').trigger('click');
//   }
// });

//////////////////////
//SCROLL ANIMTAION
//////////////////////
// URLのハッシュが存在するかチェック
 if (window.location.hash) {
  var targetId = window.location.hash.substring(1);
  var targetElement = $('#' + targetId);
  if (targetElement.length > 0) {
    targetElement.click();
    setTimeout(function() {
      var targetOffset = targetElement.offset().top;
      var bodyOffset = $('body').scrollTop();
      var scrollTo = targetOffset - bodyOffset;
      $('html, body').animate({
        scrollTop: scrollTo
      }, 800);  // スクロール時間（ミリ秒）
    }, 10);  // 適宜調整した遅延時間
  }
}

 // URLのハッシュを削除
$(window).on('scroll', function() {
  clearTimeout(window.scrollTimeout);
  window.scrollTimeout = setTimeout(function() {
    if (window.location.hash !== '') {
      history.replaceState(null, null, ' '); // ハッシュを削除
    }
  }, 150);  // スクロール停止後150ミリ秒後に実行
});


// var headerH = $("#header-pc").outerHeight(true);//headerの高さを取得
var headerH = 50;//headerの高さを取得    
function FixedAnime() {
  if ($('body').hasClass('is-sp-menu')) return;

  var scroll = $(window).scrollTop();

  if (scroll >= headerH){
    $('body').addClass('is_scroll');
  }else{
    $('body').removeClass('is_scroll');
  }
}
// 画面をスクロールをしたら動かしたい場合の記述
$(window).scroll(function () {
  FixedAnime();//スクロール途中からヘッダーの高さを変化させる関数を呼ぶ
});

// ページが読み込まれたらすぐに動かしたい場合の記述
$(window).on('load', function () {
  FixedAnime();//スクロール途中からヘッダーの高さを変化させる関数を呼ぶ
});

//=====================================
//Swiper Slide 1
//=====================================
// window.App.initializeSwiper = function(containerId, menuId, perView) {
//   if (typeof perView !== 'number' || isNaN(perView)) {
//     console.error('perView must be a number.');
//     return;
//   }

//   var menuSwiper = new Swiper(menuId, {
//     slidesPerView: perView,
//     spaceBetween: 10,
//     allowSlideNext: false,
//     allowSlidePrev: false,
//   });
//   var mainSwiper = new Swiper(containerId, {
//     loop: true,
//     spaceBetween: 0,
//     clickable: true,
//     speed: 300,
//     thumbs: {
//       swiper: menuSwiper,
//     },
//   });
// }

//=====================================
//Swiper Slide 1
//=====================================
window.App.initializeSwiper = function(containerId, menuId, perView) {
  if (typeof perView !== 'number' || isNaN(perView)) {
    console.error('perView must be a number.');
    return;
  }
  var menuSwiper = new Swiper(menuId, {
    slidesPerView: perView,
    // spaceBetween: 0,
    allowSlideNext: false,
    allowSlidePrev: false,
  });
  var mainSwiper = new Swiper(containerId, {
    loop: true,
    spaceBetween: 0,
    clickable: true,
    speed: 300,
    thumbs: {
      swiper: menuSwiper,
    },
  });
}

///////////////////////////////////////////////////////////
//FAQ ETC
//////////////////////////////////////////////////////////////
$(".lst-slidedown").find("li").on("click", function(){
  if ($(this).hasClass("shown")) {
    $(this).removeClass("shown");
  } else {
    $(this).addClass("shown");
  }
});
///////////////////////////////////////////////////////////
///MURRI
//////////////////////////////////////////////////////////////
window.App .initializeMuuri = function(muriId) {
  var gridOptions = {
  items: '*',
  showDuration: 300,
  showEasing: 'ease',
  hideDuration: 300,
  hideEasing: 'ease',
  layoutOnResize: 150,
  layoutOnInit: true,
  layoutDuration: 300,
  layoutEasing: 'ease',
  sortData: null,
  layout: {
      fillGaps: true,
      horizontal: false,
      alignRight: false,
      alignBottom: false,
      rounding: 'ceil' // 並べ方のオプションを設定[]
      // rounding:'true'
  },
  // visibleStyles: {
  // opacity: '1',
  // transform: 'scale(1)'
  // },
  // hiddenStyles: {
  // opacity: '0',
  // transform: 'scale(0.5)'
  // },
  // Drag & Drop
  // dragEnabled: true,
  // dragContainer: null,
  // dragHandle: null,
  // dragStartPredicate: {
  //   distance: 0,
  //   delay: 0
  // },
};
var gridALL = new Muuri(muriId, gridOptions);
//Random
// function randomizeOrder(items) {
//   var shuffled = items.slice(0);
//   for (var i = shuffled.length - 1; i > 0; i--) {
//     var rand = Math.floor(Math.random() * (i + 1));
//     var temp = shuffled[i];
//     shuffled[i] = shuffled[rand];
//     shuffled[rand] = temp;
//   }
//   return shuffled;
// }
function filterDo() {
var selectElms = $(".js-sort-btn .active");
var selectElemAry = [];
$.each(selectElms, function(index, selectElm) {
 var className = $(this).attr("class");
 className = className.split(' ');
 selectElemAry.push("." + className[0]);
});
var str = selectElemAry.join(',');
gridALL.filter(str);
}
// Event Function
  $('.js-sort-btn li').on('click', function() {
  $(".js-sort-btn li").removeClass("active");
  $(".cat_all").addClass("active");
  $(this).addClass("active");
  var className = $(this).attr("class");
  className = className.split(' ');
  console.log(className);
  filterDo();
});
// $('.cat_all').on('click', function() {
//   $(".js-sort-btn li").addClass("active");
//   $(".cat_all").removeClass("active");
//   filterDo();
// });
//Page loaded
// filterDo();
}


////////////////////////////////////
/// DEV
////////////////////////////////////
$(".dev-bg i").on("click", function(e) {
e.preventDefault();
var classNum = $(this).data("bg");
if(classNum === "none"){
    $(this).parent(".dev-bg").remove();
}
$(this).closest("SECTION, .swiper-slide").removeClass(function(index, className) {
    return (className.match(/(^|\s)mv-\S+/g) || []).join(" ");
}).addClass("mv-" + classNum);
});
$('[data-js="add_hover"]').hover(function() {
$(this).closest('SECTION').addClass('is_hover');
}, function() {
$(this).closest('SECTION').removeClass('is_hover');
});


//////////////////////////////
//カウントアップ
//////////////////////////////
$(".txt-num > i").each(function(index, element) {
  var $target = $(element);
  var targetText = $target.text();
  var targetNumber = parseInt(targetText, 10);
  var paddingLength = targetText.length; // 元の文字列の桁数を保持

  var duration = 500; // アニメーションの継続時間（ミリ秒）
  var currentNumber = 0; // 現在の数字

  function animateNumber() {
    $({ countNum: currentNumber }).animate({ countNum: targetNumber }, {
      duration: duration,
      easing: 'linear',
      step: function() {
        var value = Math.floor(this.countNum).toString().padStart(paddingLength, '0');
        $target.text(value);
        $target.addClass('animating').removeClass("animating_done"); 
      },
      complete: function() {
        var finalValue = targetNumber.toString().padStart(paddingLength, '0');
        $target.text(finalValue);
        $target.removeClass('animating').addClass("animating_done");
      }
    });
  }

  // カウントアップのアニメーションをスクロールトリガーとして設定
  gsap.to({}, {
    duration: 0.01,
    scrollTrigger: {
      trigger: $target.parent(), // 親要素をトリガーにする
      start: "top 80%", // スクロール位置でトリガー
      onEnter: animateNumber, // 要素がビューポートに入ったときにアニメーションを開始
      // markers: true // マーカーを表示（デバッグ用）
    }
  });
});
});

